import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import {
  looksLikeJwt,
  clearAuthStorage,
  finishSocialLogin,
} from "../SocialAuth/socialRouting";

export default function GoogleCallback() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const access = params.get("access");
      const refresh = params.get("refresh");

      if (!looksLikeJwt(access) || !looksLikeJwt(refresh)) {
        clearAuthStorage();
        toast.error("Google login error");
        navigate("/sign-in", { replace: true });
        return;
      }

      await finishSocialLogin({
        access,
        refresh,
        navigate,
        backTo: location.state?.from,
        providerName: "Google",
      });
    };

    run();
  }, [navigate, location]);

  return <div>Signing in...</div>;
}
